module.exports = __webpack_public_path__ + "static/media/ccs-home.26befc64.jpg";